
<template>
  <!-- 渠道管理 -->
  <div :class="['app-container', { 'bdc-list-page': isBdc, 'bdc-operate-aide-page': isBdc }]">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>运营渠道列表</h5>
              </span>
            </div>
            <div>
              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="adddivshow">添加运营渠道</el-button>
              <el-button slot="reference" size="mini" icon="el-icon-refresh" :loading="tongbuloading" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="tongbuqudao">同步渠道数据</el-button>
              <el-input v-model="yychannelName" size="mini" style="width:200px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="渠道名称模糊查询" />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun">查询</el-button>

              <!-- <div style="" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'xiazaizhucequdaoliebiao')" />
              </div> -->
              <!--  添加按钮  -->
              <!-- <el-dropdown style="float:right;margin: 10px;cursor: pointer;" trigger="click" size="small" placement="bottom-start">
                <el-button icon="el-icon-more" size="mini" plain>更多操作</el-button>
                <el-dropdown-menu slot="dropdown" class="more-dropdown">
                  <el-dropdown-item @click.native="exportExcel($event,'xiazaizhucequdaoliebiao')">
                    <svg-icon icon-class="download" style="width: 16px;height: 16px;margin-right: 2px" />
                    下载数据</el-dropdown-item>
                  <el-dropdown-item @click.native="batchEdit">
                    <svg-icon icon-class="edit_channel" style="width: 16px;height: 16px;margin-right: 2px" />
                    批量编辑</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" >
                <el-button size="mini" style="font-size: 12px;padding:5px 15px;margin-top:10px;" @click="batchEdit" ><svg-icon icon-class="edit_channel" style="width: 12px;height: 12px;margin-right: 5px" />批量编辑</el-button>
                <el-button v-if="!isBdc" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'xiazaiyunyingqudao')" title="下载"/>
              </div>
              <el-table :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData3.slice((currentPage3-1)*sizePage3,currentPage3*sizePage3)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1 tb-edit2'" :height="isBdc ? undefined : 441" style="width: 100%" border @filter-change="filterplatformType3" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <el-table-column prop="appChannelCode" label="运营渠道码" />
                <el-table-column prop="appChannelName" label="运营渠道名称" show-overflow-tooltip />
                <el-table-column prop="channelCode" label="注册渠道码" />
                <el-table-column prop="channelName" label="注册渠道名称" />
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-muted" @click="zidingyishijianupdate(scope.$index, scope.row)">编辑</el-button>
                      <el-button type="text" class="bdc-table-op-danger" @click="yunyingqudaodelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button size="mini" @click="exportExcel($event,'xiazaiyunyingqudao')" />
                </template>
                <pagination
                  v-show="dataLength3 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="dataLength3"
                  :page.sync="currentPage3"
                  :limit.sync="sizePage3"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                />
              </bdc-table-footer>

              <el-table id="xiazaiyunyingqudao" style="display: none;" :data="tableData3" class="tb-edit tb-edit1">
                <el-table-column prop="appChannelCode" label="运营渠道码" />
                <el-table-column prop="appChannelName" label="运营渠道名称" />
                <el-table-column prop="channelCode" label="注册渠道码" />
                <el-table-column prop="channelName" label="注册渠道名称" />
              </el-table>

            </div>

          </div>
        </el-col>
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>注册渠道列表</h5>
              </span>
            </div>

            <div>
              <!-- <el-button slot="reference" size="mini" icon="el-icon-refresh" @click="adddivshow" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">同步渠道数据</el-button> -->
              <el-select v-model="mark" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="markselect">
                <el-option label="全部渠道" value="" />
                <el-option label="游戏下渠道" value="game" />
                <!-- <el-option label="运营渠道" value="2"></el-option> -->
              </el-select>
              <!-- <el-select v-model="eventTypeselect" @change="eventshaixuaneventTypeselect" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
                <el-option label="全部事件" value=""></el-option>
                <el-option label="公共事件" value="0"></el-option>
                <el-option label="必传参数" value="3"></el-option>
                <el-option label="自定义事件" value="1"></el-option>
              </el-select> -->
              <el-input v-model="channelName" size="mini" style="width:200px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="渠道名称模糊查询" />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxunall">查询</el-button>

              <div v-if="!isBdc" style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'xiazaizhucequdaoliebiao')" />
              </div>

              <el-table :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData1.slice((currentPage1-1)*sizePage1,currentPage1*sizePage1)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1 tb-edit2'" :height="isBdc ? undefined : 441" style="width: 100%" border @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <!-- @filter-change="filterplatformType" -->
                <el-table-column prop="channelCode" label="渠道码" />
                <el-table-column prop="channelName" label="渠道名称" />
                <!--  :filters="[ { text: '公共渠道', value: '1' }, { text: '自定义渠道', value: '2' }]" :filter-multiple='false' column-key="platformType" filter-placement="bottom-end"  -->
                <el-table-column prop="type" label="渠道类型">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | platformTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="categoryName" label="渠道所属类型" />
                <el-table-column label="操作" width="210">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button v-if="scope.row.isDeleteAble == 1" type="text" class="bdc-table-op-danger" @click="zidingyishijiandelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button size="mini" @click="exportExcel($event,'xiazaizhucequdaoliebiao')" />
                </template>
                <pagination
                  v-show="dataLength1 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="dataLength1"
                  :page.sync="currentPage1"
                  :limit.sync="sizePage1"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                />
              </bdc-table-footer>

              <el-table id="xiazaizhucequdaoliebiao" style="display: none;" :data="tableData1" class="tb-edit tb-edit1">
                <el-table-column prop="channelCode" label="渠道码" />
                <el-table-column prop="channelName" label="渠道名称" />
                <el-table-column prop="type" label="渠道类型">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | platformTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="categoryName" label="渠道所属类型" />
              </el-table>

            </div>
          </div>
        </el-col>
        <!-- 镜像渠道列表 -->
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>镜像渠道列表</h5>
              </span>
            </div>

            <div>
              <!-- <el-button slot="reference" size="mini" icon="el-icon-refresh" @click="adddivshow" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">同步渠道数据</el-button> -->
              <el-select v-model="mirror.mark" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="mirrorMohuchaxunall">
                <el-option label="全部镜像渠道" value="" />
                <el-option label="游戏下镜像渠道" value="game" />
                <!-- <el-option label="运营渠道" value="2"></el-option> -->
              </el-select>
              <!-- <el-select v-model="eventTypeselect" @change="eventshaixuaneventTypeselect" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
                <el-option label="全部事件" value=""></el-option>
                <el-option label="公共事件" value="0"></el-option>
                <el-option label="必传参数" value="3"></el-option>
                <el-option label="自定义事件" value="1"></el-option>
              </el-select> -->
              <el-input v-model="mirror.channelName" size="mini" style="width:200px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="镜像渠道模糊查询" />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mirrorMohuchaxunall">查询</el-button>

              <div v-if="!isBdc" style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event,'xiazaijingxiangqudao')" />
              </div>

              <el-table :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData5.slice((currentPage5-1)*sizePage5,currentPage5*sizePage5)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1 tb-edit2'" :height="isBdc ? undefined : 441" style="width: 100%" border @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <!-- @filter-change="filterplatformType" -->
                <el-table-column prop="imgChannelCode" label="镜像渠道码" />
                <el-table-column prop="imgChannelName" label="镜像渠道名称" />
                <el-table-column prop="channelCode" label="所属注册渠道" />
                <el-table-column prop="channelName" label="注册渠道名称" />

                <el-table-column label="操作" width="210">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button v-if="scope.row.isDeleteAble == 1" type="text" class="bdc-table-op-danger" @click="mirrorDelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button size="mini" @click="exportExcel($event,'xiazaijingxiangqudao')" />
                </template>
                <pagination
                  v-show="dataLength5 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="dataLength5"
                  :page.sync="currentPage5"
                  :limit.sync="sizePage5"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                />
              </bdc-table-footer>

              <el-table id="xiazaijingxiangqudao" style="display: none;" :data="tableData5" class="tb-edit tb-edit1">
                <el-table-column prop="imgChannelCode" label="镜像渠道码" />
                <el-table-column prop="imgChannelName" label="镜像渠道名称" />
                <!-- todo -->
                <el-table-column prop="channelCode" label="所属注册渠道" />
                <el-table-column prop="channelName" label="注册渠道名称" />
                <!-- <el-table-column prop="type" label="渠道类型">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | platformTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="categoryName" label="渠道所属类型" /> -->
              </el-table>

            </div>
          </div>
        </el-col>

      </el-row>
      <!-- 添加运营渠道 -->
      <el-dialog append-to-body title="添加运营渠道" :visible.sync="adddivif" width="400px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="form" label-width="120px">
          <el-form-item label="注册渠道">
            <el-select v-model="form.channelCode" style="width:200px" placeholder="">
              <el-option v-for="item in yyqudaoliebiao" :key="item.channelCode" :label="item.channelName" :value="item.channelCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="运营渠道码">
            <el-input v-model="form.appChannelCode" placeholder="小写字母加下划线" style="width:200px" />
          </el-form-item>
          <el-form-item label="运营渠道名称">
            <el-input v-model="form.appChannelName" style="width:200px" maxlength="150" />
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmit">添加</el-button>
            <el-button @click="hidedivshow">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑运营渠道 -->
      <el-dialog append-to-body title="编辑运营渠道" :visible.sync="updatedivif" width="400px" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="uform" label-width="120px">
          <el-form-item label="注册渠道">
            <el-select v-model="uform.channelCode" style="width:200px" placeholder="">
              <el-option v-for="item in yyqudaoliebiao" :key="item.channelCode" :label="item.channelName" :value="item.channelCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="运营渠道码">
            <el-input v-model="uform.appChannelCode" placeholder="小写字母加下划线" style="width:200px" />
          </el-form-item>
          <el-form-item label="运营渠道名称">
            <el-input v-model="uform.appChannelName" maxlength="150" style="width:200px" />
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmituform">保存修改</el-button>
            <el-button @click="hidedivshowuform">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 批量编辑运营渠道 -->
      <el-dialog append-to-body class="batch-upload" title="批量编辑-上传文件" :visible.sync="batchDia" :width="JSON.stringify(uploadRecord) == '{}' ? '700px' : '420px'" :close-on-click-modal="false">
        <template v-if="JSON.stringify(uploadRecord) == '{}'">
          <div style="font-size: 14px;margin-bottom: 16px;">
            <span style="margin-right: 18px;color: #666666;">第一步:</span>
            <span style="margin-right: 3px;color: #333;">下载<el-link :underline="false" type="primary" @click="downloadTemplate">《运营渠道名称批量上传格式模板》</el-link></span>
          </div>
          <div style="font-size: 14px;margin-bottom: 12px;">
            <span style="margin-right: 18px;color: #666666;">第二步:</span>
            <span style="margin-right: 3px;color: #333;">上传填写好的模板</span>
          </div>
          <div style="padding-left: 70px">
            <!-- 文件上传  -->
            <el-upload v-show="fileList.length == 0" ref="upload" class="file-upload" :show-file-list="false" :auto-upload="false" accept=".xls,.xlsx" :headers="uploadHeaders" :action="actionUrl" :limit="1" :with-credentials="false" :on-change="loadFile" :on-exceed="onExceed" :on-success="loadSuccess" :file-list="fileList">
              <el-button size="mini" style="padding: 5px 12px;">
                <svg-icon icon-class="upload" style="width: 16px;height: 16px;margin-right: 4px;" />
                上传文件
              </el-button>
            </el-upload>

            <!-- 已上传文件列表  -->
            <div v-show="fileList.length != 0" class="uploaded-file">
              <div class="file">
                <svg-icon class="file-svg" icon-class="file" />
                <span class="file-name">{{ fileList[0] ? fileList[0].name : '' }}</span>
              </div>
              <div class="handle">
                <i class="el-icon-circle-check right-svg success-svg" />
                <i class="el-icon-close right-svg handle-svg" @click="deleteFile" />
              </div>
            </div>
            <div style="margin-top: 12px;">
              <span style="color: #999999">仅支持xls、xlsx格式文件，最多可上传一个文件</span>
            </div>
            <div v-if="isBdc" class="bdc-channel-upload-tip">
              <svg-icon icon-class="bdc-icon-attention" class="bdc-channel-upload-tip__icon" />
              <div class="bdc-channel-upload-tip__text">
                1. 只支持修改【运营渠道名称】这1个字段，存在重复数据时以第一条为准</br>
                2. 当“运营渠道码+注册渠道码”均相同时，才视为重复数据</br>
                3. 第一列为空的数据无法解析，上传记录数不会统计该条数据
              </div>
            </div>
            <div v-else style="margin: 12px 0px 20px 0px;width: 564px;background: rgba(255,150,62,0.1);border-radius: 6px;border: 1px solid rgba(255,150,62,0.1);color: #FF963E;padding: 5px 44px;position: relative">
              <i class="el-icon-warning" style="font-size: 16px;position: absolute;top: 8px;left: 16px;" />
              <div style="line-height: 22px">
                1. 只支持修改【运营渠道名称】这1个字段，存在重复数据时以第一条为准</br>
                2. 当“运营渠道码+注册渠道码”均相同时，才视为重复数据</br>
                3. 第一列为空的数据无法解析，上传记录数不会统计该条数据
              </div>
            </div>
          </div>
          <div slot="footer">
            <el-button @click="cancelBatch">取消</el-button>
            <el-button style="margin-left:12px;" type="primary" @click="handleBatch">上传</el-button>
          </div>
        </template>

        <!--  上传成功  -->
        <div v-else class="success-block">
          <svg-icon icon-class="success" class="item-icon" style="width: 56px;height: 56px;" />
          <div class="success-title">上传成功</div>
          <div class="success-detail">
            <div class="detail-block">
              <span class="detail-title">上传记录数：</span>
              <span class="detail-text">{{ uploadRecord.totalSize }}</span>
            </div>
            <div class="detail-block">
              <span class="detail-title">成功导入数：</span>
              <span class="detail-text">{{ uploadRecord.successSize }}</span>
            </div>
            <div class="detail-block" style="display: flex">
              <span class="detail-title">失败行数：</span>
              <span class="detail-text">{{ uploadRecord.errorSize }}</span>
              <el-link type="primary" :underline="false" :href="uploadRecord.url" style="margin-left: 16px">下载失败明细 ></el-link>
            </div>
          </div>
          <div style="display: flex;width: 100%;justify-content: flex-end;margin-top: 40px">
            <el-button type="primary" @click="cancelBatch">完成</el-button>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcDownloadButton from '@/components/BdcTableFooter/BdcDownloadButton'
import {
  queryChannelList,
  queryCategoryList,
  deleteChannelById,
  queryAppChannelList,
  syncChannelData,
  saveAppChannel,
  updateAppChannel,
  deleteAppChannelById,
  imgQueryChannelList,
  imgDeleteChannelById
} from '@Bdc~/api/ajax_model'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { apiUrl } from '../../api/env'
import store from '@Sys~/store'

import bdcTableCrosshair from '@Bdc~/utils/bdcTableCrosshair'

export default {
  name: '',
  components: { Pagination, BdcTableFooter, BdcDownloadButton },
  mixins: [bdcTableCrosshair],
  filters: {
    delFlags(value) {
      if (value == '0') {
        return '显示'
      } else if (value == '1') {
        return '隐藏'
      }
    },
    platformTypes(value) {
      if (value == '1') {
        return '公共渠道'
      } else if (value == '2') {
        return '自定义渠道'
      }
    },
    eventTypes(value) {
      if (value == '0') {
        return '公共事件'
      } else if (value == '3') {
        return '必传参数'
      } else if (value == '1') {
        return '自定义事件'
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + '...'
      } else {
        return value
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + '...'
      } else {
        return value
      }
    },
    dataEmptys(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    },
    ispresets(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    }
  },
  data() {
    return {
      batchDia: false, // 批量编辑弹窗
      uploadRecord: {}, // 上传后的状态 成功还是失败
      // 上传携带头部信息
      uploadHeaders: {
        'appkey': store.getters.appkey
      },
      // 上传后台地址
      actionUrl: apiUrl.gateUrl + '/api/channel/import/update',
      // 上传的文件列表
      fileList: [],

      form: {
        appkey: this.$store.getters.appkey,
        channelCode: '',
        appChannelCode: '',
        appChannelName: ''
      },
      uform: {
        id: '',
        appkey: '',
        channelCode: '',
        appChannelCode: '',
        appChannelName: ''
      },
      csform: {
        appkey: this.$store.getters.appkey,
        sasEventCode: '',
        dataKey: '',
        dataType: '1',
        ruleType: '0',
        dataEmpty: '1',
        dataDesc: '',
        effectiveTimeData: ''
      },
      csuform: {
        id: '',
        appkey: '',
        sasEventCode: '',
        dataKey: '',
        dataType: '',
        ruleType: '',
        dataEmpty: '',
        dataDesc: '',
        effectiveTimeData: ''
      },
      tongbuloading: false,
      adddivif: false,
      updatedivif: false,
      eventdivif: false,
      dialogTableVisible: false,
      adddivifcanshu: false,
      updatedivifcanshu: false,
      shijianxiangqing: '',
      mark: '',
      channelName: '',
      yychannelName: '',
      platformTypeszidingyi: '',
      eventTypeselect: '',
      eventcode: '',
      // 镜像渠道查询参数
      mirror: {
        channelName: '',
        mark: ''
      },

      zdydialogTableVisible: false,
      zdyshijianxiangqing: '',

      tableData: [],
      currentPage: 1,
      dataLength: 1,
      sizePage: 10,

      //注册渠道列表
      tableData1: [],
      currentPage1: 1,
      dataLength1: 1,
      sizePage1: 10,

      tableData2: [],
      currentPage2: 1,
      dataLength2: 1,
      sizePage2: 10,

      //运营渠道列表
      tableData3: [],
      currentPage3: 1,
      dataLength3: 1,
      sizePage3: 10,

      tableData4: [],
      currentPage4: 1,
      dataLength4: 1,
      sizePage4: 10,

      //镜像渠道表格
      tableData5: [],
      currentPage5: 1,
      dataLength5: 1,
      sizePage5: 10,

      CategoryList: [],
      yyqudaoliebiao: []
    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  },
  created() {
    // this.queryChannelList();
    this.queryCategoryList()
    this.queryAppChannelList()
    this.yyqudaoliebiaolist()
    this.queryMirrorChannelList()
  },
  mounted() { },
  methods: {
    tongbuqudao() {
      this.tongbuloading = true
      syncChannelData('').then(
        response => {
          console.log(response)
          if (response.code == 1) {
            this.$message({
              message: response.data,
              type: 'success'
            })
            this.queryCategoryList()
            this.queryAppChannelList()
          }
          this.tongbuloading = false
        }
      )
    },
    // queryChannelList() {
    //   //渠道列表
    //   queryChannelList().then(response => {
    //     console.log(response);
    //     if (response.statusCode == 1) {
    //       this.tableData = response.data;
    //       this.dataLength = response.data.length;
    //     }
    //   });
    // },
    yyqudaoliebiaolist() {
      queryChannelList('', 'game').then(
        response => {
          console.log(response)
          if (response.code == 1) {
            this.yyqudaoliebiao = response.data
          }
        }
      )
    },
    queryChannelList() {
      queryChannelList(this.channelName, this.mark).then(
        response => {
          console.log(response)
          if (response.code == 1) {
            for (var s = 0; s < response.data.length; s++) {
              for (var i = 0; i < this.CategoryList.length; i++) {
                if (response.data[s].category == this.CategoryList[i].category) {
                  response.data[s].categoryName = this.CategoryList[i].categoryName
                }
              }
            }
            this.tableData1 = response.data
            this.dataLength1 = response.data.length
          }
        }
      )
    },
    queryCategoryList() {
      queryCategoryList().then(response => {
        console.log(response)
        if (response.code == 1) {
          this.CategoryList = response.data
          this.queryChannelList()
        }
      })
    },
    // queryMirrorChannelList
    queryMirrorChannelList() {
      //todo
      imgQueryChannelList(this.mirror.channelName, this.mirror.mark).then(
        response => {
          console.log(response)
          if (response.code == 1) {
            // for (var s = 0; s < response.data.length; s++) {
            //   for (var i = 0; i < this.CategoryList.length; i++) {
            //     if (response.data[s].category == this.CategoryList[i].category) {
            //       response.data[s].categoryName = this.CategoryList[i].categoryName
            //     }
            //   }
            // }
            this.tableData5 = response.data
            this.dataLength5 = response.data.length
          }
        }
      )
    },
    queryEventInfo() {
      // 公共事件详情
      queryEventInfo(this.eventcode).then(response => {
        console.log(response)
        if (response.statusCode == 1) {
          this.tableData2 = response.data
          this.dataLength2 = response.data.length
        }
      })
    },
    queryAppChannelList() {
      queryAppChannelList(
        this.yychannelName
      ).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.tableData3 = response.data
          this.dataLength3 = response.data.length
        }
      })
    },
    queryCustomEventInfo() {
      // 自定义事件详情
      queryCustomEventInfo(this.eventcode).then(
        response => {
          console.log(response)
          if (response.statusCode == 1) {
            this.tableData4 = response.data
            this.dataLength4 = response.data.length
          }
        }
      )
    },
    chakanxiangqing(index, row) {
      // 查看事件详情
      this.dialogTableVisible = true
      this.shijianxiangqing = '事件详情：' + row.eventName
      this.eventcode = row.eventCode
      this.queryEventInfo()
    },
    zidingyichakanxiangqing(index, row) {
      // 查看自定义事件详情
      this.zdydialogTableVisible = true
      this.zdyshijianxiangqing = '事件详情：' + row.eventName
      this.eventcode = row.eventCode
      this.csform.sasEventCode = this.eventcode
      this.queryCustomEventInfo()
    },
    zidingyishijianupdate(index, row) {
      // 自定义事件编辑
      console.log(row)
      this.updatedivif = true
      this.uform = JSON.parse(JSON.stringify(row))
    },
    yunyingqudaodelete(index, row) {
      // 运营渠道删除
      this.$confirm('确认删除 "' + row.appChannelName + '" 吗？')
        .then(_ => {
          deleteAppChannelById(row.id).then(
            response => {
              console.log(response)
              if (response.code == 1) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.queryAppChannelList()
              }
            }
          )
        })
        .catch(_ => { })
    },
    zidingyishijiandelete(index, row) {
      // 渠道删除
      this.$confirm('确认删除 "' + row.channelName + '" 吗？')
        .then(_ => {
          deleteChannelById(row.gameChannelId).then(
            response => {
              console.log(response)
              if (response.code == 1) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.queryChannelList()
              }
            }
          )
        })
        .catch(_ => { })
    },
    zidingyishijianshuxingdelete(index, row) {
      // 自定义事件属性删除
      this.$confirm('确认删除 "' + row.dataKey + '" 吗？')
        .then(_ => {
          deleteEventDataById(row.id).then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.queryCustomEventInfo()
            }
          })
        })
        .catch(_ => { })
    },
    //镜像渠道删除
    mirrorDelete(index, row) {
      // 渠道删除
      this.$confirm('确认删除 "' + row.imgChannelName + '" 吗？')
        .then(_ => {
          imgDeleteChannelById(row.gameChannelId).then(
            response => {
              console.log(response)
              if (response.code == 1) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.queryMirrorChannelList()
              }
            }
          )
        })
        .catch(_ => { })
    },
    // filterplatformType(filters) {
    //   // 筛选所选项下的所有数据，需要调用后端接口
    //   console.log(filters);
    //   if (filters.platformType) {
    //     if (filters.platformType.length > 0) {
    //       this.platformTypes = filters.platformType[0];
    //     } else {
    //       this.platformTypes = "";
    //     }
    //   }

    //   if (filters.eventType) {
    //     if (filters.eventType.length > 0) {
    //       this.eventTypeselect = filters.eventType[0];
    //     } else {
    //       this.eventTypeselect = "";
    //     }
    //   }
    //   this.queryCommonEventList();
    // },
    filterplatformType3(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters.platformType)
      if (filters.platformType.length > 0) {
        this.platformTypeszidingyi = filters.platformType[0]
      } else {
        this.platformTypeszidingyi = ''
      }
      this.queryCustomEventList()
    },
    markselect(e) {
      this.mark = e
      this.currentPage1 = 1
      this.queryChannelList()
    },
    mohuchaxunall() {
      this.currentPage1 = 1
      this.queryCategoryList()
    },
    // mirrorMarkselect(e) {
    //   this.mirror.mark = e
    //   this.currentPage5 = 1
    //   this.queryMirrorChannelList()
    // },
    mirrorMohuchaxunall() {
      this.currentPage5 = 1
      this.queryMirrorChannelList()
    },
    mohuchaxun() {
      this.currentPage3 = 1
      this.queryAppChannelList()
    },
    onSubmit() {
      // 添加自定义事件
      var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(this.form.appChannelCode)) {
        this.$message({
          message: '运营渠道码不可包含汉字',
          type: 'danger'
        })
        return false
      }
      console.log(this.form)
      saveAppChannel(this.form).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.queryAppChannelList()
          this.adddivif = false
        }
      })
    },
    onSubmituform() {
      var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(this.uform.appChannelCode)) {
        this.$message({
          message: '运营渠道码不可包含汉字',
          type: 'danger'
        })
        return false
      }
      // 修改自定义事件
      this.uform.appkey = this.$store.getters.appkey
      console.log(this.uform)
      updateAppChannel(this.uform).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.queryAppChannelList()
          this.updatedivif = false
        }
      })
    },

    adddivshow() {
      this.form = {
        appkey: this.$store.getters.appkey,
        channelCode: '',
        appChannelCode: '',
        appChannelName: ''
      }
      this.adddivif = true
    },
    hidedivshow() {
      this.adddivif = false
    },
    hidedivshowuform() {
      this.updatedivif = false
    },
    hidedivshowcanshuadd() {
      this.adddivifcanshu = false
    },
    hidedivshowcanshuupdate() {
      this.updatedivifcanshu = false
    },
    hideeventdiv() {
      this.eventdivif = false
    },
    adddivshowcanshu() {
      this.adddivifcanshu = true
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.sizePage = e
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.currentPage = e
    },
    handleSizeChange1(e) {
      // table 分页数量变化
      this.sizePage1 = e
    },
    handleCurrentChange1(e) {
      // table 分页变化
      this.currentPage1 = e
    },
    handleSizeChange2(e) {
      // table 分页数量变化
      this.sizePage2 = e
    },
    handleCurrentChange2(e) {
      // table 分页变化
      this.currentPage2 = e
    },
    handleSizeChange3(e) {
      // table 分页数量变化
      this.sizePage3 = e
    },
    handleCurrentChange3(e) {
      // table 分页变化
      this.currentPage3 = e
    },
    handleSizeChange4(e) {
      // table 分页数量变化
      this.sizePage4 = e
    },
    handleCurrentChange4(e) {
      // table 分页变化
      this.currentPage4 = e
    },
    //镜像渠道
    handleSizeChange5(e) {
      // table 分页数量变化
      this.sizePage5 = e
    },
    handleCurrentChange5(e) {
      // table 分页变化
      this.currentPage5 = e
    },

    // 下载模板
    downloadTemplate() {
      // 创建一个<a></ a>标签
      const a = document.createElement('a')
      a.href = '/运营渠道名称批量上传格式模板.xlsx'
      a.download = '运营渠道名称批量上传格式模板.xlsx'

      // 障眼法藏起来a标签
      a.style.display = 'none'
      // 将a标签追加到文档对象中
      document.body.appendChild(a)
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click()
      // 一次性的,用完就删除a标签
      a.remove()
    },

    // 批量编辑
    batchEdit() {
      this.batchDia = true
      this.fileList = []
      this.uploadRecord = {}
    },

    // 取消批量弹窗
    cancelBatch() {
      this.fileList = []
      this.batchDia = false
    },

    // 确定上传
    handleBatch() {
      if (this.fileList.length) {
        this.$refs.upload.submit()
      }
    },

    // 删除已上传的文件
    deleteFile() {
      this.fileList = []
    },

    // 加载文件内容
    loadFile(file, fileList) {
      if (!file.name.endsWith('.xls') && !file.name.endsWith('.xlsx')) {
        this.$message({ type: 'error', message: '仅支持上传xls或xlsx格式文件，请修改后上传' })
        this.$refs.upload.clearFiles()
      }
      this.fileList = fileList
    },

    // 重新上传的文件
    onExceed(file, fileList) {
      // this.$refs['upload'].clearFiles()// 清除文件
      // this.$refs['upload'].handleStart(file[0])// 选择文件后的赋值方法
    },

    // 文件上传成功
    loadSuccess(res, file, fileList) {
      if (res.code == 1) {
        this.uploadRecord = res.data
      } else {
        this.$message({ type: 'error', message: res.msg || '上传失败' })
        this.$refs.upload.clearFiles()
      }
    },

    // 下载
    exportExcel(e, id) {
      const gameName = store.getters.gameOptions.find(item => item.appkey == store.getters.appkey).name
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#' + id))
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          gameName + (id == 'xiazaiyunyingqudao' ? '_运营渠道文件.xlsx' : id == 'xiazaizhucequdaoliebiao' ? '_注册渠道文件.xlsx' : '_镜像渠道文件.xlsx')
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.tb-edit2 tr td {
  padding: 0px 0px;
  height: 40px;
  line-height: 40px;
}
.el-table th {
  background-color: #fff;
}
/* .el-table .el-table--medium th, .el-table--medium td{
  padding: 0;
  height: 40px;
  line-height: 40px;
} */
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.more-dropdown {
  margin-top: 4px !important;
  border-radius: 8px;
  ::v-deep .popper__arrow {
    display: none;
  }
  ::v-deep .el-dropdown-menu__item {
    color: #333333;
  }
  ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    background: #ebf3ff;
    color: #333333;
  }
}

.batch-upload {
  ::v-deep .el-dialog__body {
    padding: 15px 32px;
  }
}

.uploaded-file {
  width: 500px;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 0;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: rgba(58, 137, 255, 0.1);
    .success-svg {
      display: none;
    }
    .handle-svg {
      display: block;
    }
  }

  .file {
    display: flex;
    align-items: center;
    .file-svg {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
  }
  .right-svg {
    font-size: 20px;
    float: right;
  }
  .success-svg {
    color: #3a89ff;
    display: block;
  }
  .handle-svg {
    cursor: pointer;
    display: none;
  }
}

.success-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0px 10px;
  .success-title {
    font-size: 16px;
    margin: 8px 0px 24px 0px;
    color: #333333;
  }

  .success-detail {
    padding: 12px 16px;
    width: 100%;
    line-height: 22px;
    background: #f9f9f9;
    border: 1px solid #e5e5e5;
    .detail-block + .detail-block {
      margin-top: 4px;
    }
    .detail-title {
      color: #666666;
    }
    .detail-text {
      color: #333333;
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
body:not(.bdc-app-body) .el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
</style>
